"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _models = require("@seedlang/models");
var _serializr = require("serializr");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var FAQ_ITEMS = [{
  question: 'What are reviews?',
  answer: 'Reviews are cards that are created for words or sentences that you would like to learn. They use a "spaced repetition system" to plan how often you see the card based on how well you remember it over time.'
}, {
  question: 'Where do I find my reviews?',
  answerWeb: 'Reviews can be found on the home page. This is the deck that opens your reviews:',
  answerMobile: 'Reviews can be found on the home screen. This is the deck that opens your reviews:',
  image: 'reviews_deck.png',
  imageSlug: 'reviews_deck',
  imageWidth: 200,
  imageHeight: 200,
  webRoute: 'reviews.home',
  mobileRoute: 'Home'
}, {
  question: 'How do I manage my reviews?',
  answerWeb: 'There is a "Reviews List" button on the home page that can be clicked to see a list of your reviews.',
  answerMobile: 'There is a "Reviews List" button on the home screen that can be clicked to see a list of your reviews.'
}, {
  question: 'How many reviews are too many?',
  answer: 'This is different for everyone, but a good strategy would be to make your first priority keeping up to date with your past reviews, and only adding new reviews when you are caught up.'
}];
var DeckSummaryCardWrapper = function DeckSummaryCardWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "loadingReviewCards", _descriptor, _this);
      _initializerDefineProperty(_this, "hasLearnedWords", _descriptor2, _this);
      _initializerDefineProperty(_this, "showFaq", _descriptor3, _this);
      _initializerDefineProperty(_this, "reviewCards", _descriptor4, _this);
      _initializerDefineProperty(_this, "updatedDeckId", _descriptor5, _this);
      _this.onReviewAllForCardType = function (cardTypeId) {
        _state.AppUI.set('reloadReviewDecks', true);
        var cards = _this.cardsForPotentialReview.filter(function (item) {
          return item.cardType.id === cardTypeId;
        });
        var cardIds = cards.map(function (item) {
          return item.id;
        });
        (0, _lodash.each)(cards, function (card) {
          _state.DeckUI.addCardToReviewCards(card, _this.deckId);
        });
        _state.DeckUI.deckStore.addAllToReviews({
          ids: {
            deckId: _this.deckId
          },
          data: {
            card_ids: cardIds
          }
        }, function () {
          (0, _lodash.each)(cards, function (card) {
            var _card$cardType, _card$translation;
            _state.AppUI.createEvent('reviews - add review', {
              review_creation_source: 'deck_summary_card',
              card_type: (_card$cardType = card.cardType) === null || _card$cardType === void 0 ? void 0 : _card$cardType.slug,
              deck_id: _this.deckId,
              translation: (_card$translation = card.translation) === null || _card$translation === void 0 ? void 0 : _card$translation.targetText,
              front_text: card.frontText,
              back_text: card.backText,
              language_id: card.languageId
            });
          });
          _state.DeckUI.getReviewCards(_this.deckId);
        });
      };
      _this.getLearnedWords = function () {
        _state.DeckUI.wordStore.getIndex({
          queryStrings: {
            vocab_list: true
          },
          filters: {
            translation_ids: _this.wordCardIds
          }
        }, _this.afterGetLearnedWords);
      };
      _this.afterGetLearnedWords = function (resp) {
        _state.DeckUI.wordStore.setIndexData(resp);
        _this.hasLearnedWords = true;
      };
      _this.onToggleLearned = function (wordId) {
        var word = _state.DeckUI.wordStore.indexData.find(function (item) {
          return item.id === wordId;
        });
        if (word) {
          word.set('learned', !word.learned);
        } else {
          word = (0, _serializr.deserialize)(_models.Word, {
            id: wordId,
            learned: true
          });
          _state.DeckUI.wordStore.indexData.push(word);
        }
        _state.AppUI.createOrUpdateUserTranslation(word, {
          learned: word.learned
        }, _this.afterCreateUserTranslation.bind(_this, word));
      };
      _this.afterCreateUserTranslation = function (word, resp) {
        word.set('userTranslationId', resp.userTranslationId);
      };
      _this.isLearned = function (wordId) {
        return wordId && _state.DeckUI.wordStore.hasIndexData && _state.DeckUI.wordStore.indexData.find(function (item) {
          return item.id === wordId && item.learned;
        });
      };
      _this.userCardForId = function (cardId) {
        return _state.DeckUI.userDeck.userCards.find(function (item) {
          return item.cardId === cardId;
        });
      };
      _this.toggleShowFaq = function () {
        _this.showFaq = !_this.showFaq;
      };
      _this.getReviewDecks = function () {
        _state.AppUI.reviewDeckStore.getIndex({});
      };
      _this.onSetDeckId = function (deckId) {
        _this.updatedDeckId = deckId;
      };
      _this.allReviewsSelectedForCardType = function (cardTypeId) {
        var _this$cardsForPotenti;
        var cards = (_this$cardsForPotenti = _this.cardsForPotentialReview) === null || _this$cardsForPotenti === void 0 ? void 0 : _this$cardsForPotenti.filter(function (item) {
          return item.cardType.id === cardTypeId;
        });
        return (0, _utils.isPresent)(cards) && cards.every(function (card) {
          return (0, _utils.isPresent)(_this.findReviewCardForCard(card));
        });
      };
      _this.showCardInSummary = function (card) {
        return card.hasTranslation || card.exerciseCard;
      };
      _this.exerciseForCard = function (card) {
        var _card$exercise, _DeckUI$deck;
        if ((0, _utils.isPresent)((_card$exercise = card.exercise) === null || _card$exercise === void 0 ? void 0 : _card$exercise.id)) {
          return card.exercise;
        }
        if (!card.exerciseId || !((_DeckUI$deck = _state.DeckUI.deck) !== null && _DeckUI$deck !== void 0 && _DeckUI$deck.exercises)) {
          return null;
        }
        return _state.DeckUI.deck.exercises.find(function (item) {
          return item.id === card.exerciseId;
        });
      };
      _this.summaryTranslationForCard = function (card) {
        var _DeckUI$deck2;
        return card.summaryTranslation(_this.exerciseForCard(card), card.languageId || ((_DeckUI$deck2 = _state.DeckUI.deck) === null || _DeckUI$deck2 === void 0 ? void 0 : _DeckUI$deck2.languageId));
      };
      _this.findReviewCardForCard = function (card) {
        if ((0, _utils.isBlank)(_state.DeckUI.reviewCards)) return null;
        return _state.DeckUI.reviewCards.find(function (reviewCard) {
          return _this.reviewCardMatchesCard(card, reviewCard) && reviewCard.deckId === _this.deckId;
        });
      };
      _this.getDecksWithReviewCard = function (card) {
        var _DeckUI$reviewCards;
        if ((0, _utils.isBlank)(_state.DeckUI.reviewCards)) return '';
        var decks = (_DeckUI$reviewCards = _state.DeckUI.reviewCards) === null || _DeckUI$reviewCards === void 0 || (_DeckUI$reviewCards = _DeckUI$reviewCards.filter(function (reviewCard) {
          return _this.reviewCardMatchesCard(card, reviewCard) && reviewCard.deckId !== _this.deckId;
        })) === null || _DeckUI$reviewCards === void 0 ? void 0 : _DeckUI$reviewCards.map(function (reviewCard) {
          var _AppUI$filteredReview;
          return (_AppUI$filteredReview = _state.AppUI.filteredReviewDecks) === null || _AppUI$filteredReview === void 0 || (_AppUI$filteredReview = _AppUI$filteredReview.find(function (reviewDeck) {
            return reviewDeck.id === reviewCard.deckId;
          })) === null || _AppUI$filteredReview === void 0 ? void 0 : _AppUI$filteredReview.name;
        }).filter(Boolean);
        return (decks === null || decks === void 0 ? void 0 : decks.join(', ')) || '';
      };
      _this.reviewCardMatchesCard = function (card, reviewCard) {
        var _card$word, _card$sentence;
        var matchesExercise = (0, _utils.isPresent)(card.exerciseId) && reviewCard.sourceCardId === card.id;
        var matchesWord = (0, _utils.isPresent)((_card$word = card.word) === null || _card$word === void 0 ? void 0 : _card$word.id) && reviewCard.translationId === card.word.id;
        var matchesSentence = (0, _utils.isPresent)((_card$sentence = card.sentence) === null || _card$sentence === void 0 ? void 0 : _card$sentence.id) && reviewCard.translationId === card.sentence.id;
        return (matchesExercise || matchesWord || matchesSentence) && reviewCard.cardTypeId === card.cardTypeId && reviewCard.pronoun === card.pronoun && reviewCard.tenseConceptId === card.tenseConceptId && _this.reviewCardMatchesSynonymAssociation(card, reviewCard);
      };
      _this.reviewCardMatchesSynonymAssociation = function (card, reviewCard) {
        var _card$cardType2;
        if (((_card$cardType2 = card.cardType) === null || _card$cardType2 === void 0 ? void 0 : _card$cardType2.slug) !== 'synonym') {
          return true;
        }
        return card.synonymAssociationId === reviewCard.synonymAssociationId;
      };
      _this.getReviewDecks();
      if (_state.DeckUI.hasDeck) {
        if ((0, _utils.isPresent)(_this.wordCardIds)) {
          _this.getLearnedWords();
        } else {
          _this.hasLearnedWords = true;
        }
      }
      _state.AppUI.createEvent('deck - finish deck', {
        deck_id: _state.DeckUI.deck.id,
        language_id: _state.DeckUI.deck.languageId,
        deck_type: _state.DeckUI.deckTypeForAnalytics()
      });
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "showCard",
      get: function get() {
        return !this.loadingReviewCards && this.hasLearnedWords;
      }
    }, {
      key: "deckId",
      get: function get() {
        if ((0, _utils.isPresent)(this.updatedDeckId)) {
          return this.updatedDeckId;
        }
        return _state.AppUI.defaultReviewDeckId;
      }
    }, {
      key: "wordCardIds",
      get: function get() {
        if (_state.DeckUI.deck && _state.DeckUI.deck.vocabWordTranslateCards) {
          return _state.DeckUI.deck.vocabWordTranslateCards.map(function (item) {
            return item.word.id;
          });
        }
        if (_state.DeckUI.deck && _state.DeckUI.deck.pluralDeck) {
          return _state.DeckUI.deck.pluralCards.map(function (item) {
            return item.word.id;
          });
        }
        if (_state.DeckUI.deck && _state.DeckUI.deck.genderDeck) {
          return _state.DeckUI.deck.genderCards.map(function (item) {
            return item.word.id;
          });
        }
        if (_state.DeckUI.deck && _state.DeckUI.deck.synonymDeck) {
          return _state.DeckUI.deck.synonymCards.map(function (item) {
            return item.word.id;
          });
        }
      }
    }, {
      key: "cardTypesForPotentialReview",
      get: function get() {
        return (0, _lodash.uniqBy)(this.cardsForPotentialReview.map(function (item) {
          return {
            cardTypeId: item.cardType.id,
            cardTypeName: item.cardType.name
          };
        }), 'cardTypeId');
      }
    }, {
      key: "cardsForPotentialReview",
      get: function get() {
        if (!_state.DeckUI.hasDeck) {
          return;
        }
        if (_state.DeckUI.deck.pluralDeck) {
          return _state.DeckUI.deck.pluralCards;
        } else if (_state.DeckUI.deck.conjugationDeck || _state.DeckUI.deck.conjugationWithVideoDeck) {
          return _state.DeckUI.deck.conjugationAndTranslationCards;
        } else if (_state.DeckUI.deck.genderDeck) {
          return _state.DeckUI.deck.genderCards;
        } else if (_state.DeckUI.deck.synonymDeck) {
          return _state.DeckUI.deck.synonymCards;
        } else if (_state.DeckUI.deck.numberDeck) {
          return _state.DeckUI.deck.numberCards;
        } else if (_state.DeckUI.deck.pronunciationDeck) {
          return _state.DeckUI.deck.pronunciationCards;
        } else if (_state.DeckUI.deck.caseDeck) {
          return _state.DeckUI.deck.caseCards;
        } else {
          return _state.DeckUI.deck.translationAndComprehensionCards.concat(_state.DeckUI.deck.exerciseCards);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        try {
          if (_state.AppUI.layout.isNative) {
            _state.VocabUI.getWords();
          }
        } catch (error) {
          console.error('Error during componentWillUnmount:', error);
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          hasLearnedWords: this.hasLearnedWords,
          showCard: this.showCard,
          wordCardIds: this.wordCardIds,
          cardsForPotentialReview: this.cardsForPotentialReview,
          cardTypesForPotentialReview: this.cardTypesForPotentialReview,
          getLearnedWords: this.getLearnedWords,
          afterGetLearnedWords: this.afterGetLearnedWords,
          onToggleLearned: this.onToggleLearned,
          afterCreateUserTranslation: this.afterCreateUserTranslation,
          isLearned: this.isLearned,
          userCardForId: this.userCardForId,
          onReviewAllForCardType: this.onReviewAllForCardType,
          showFaq: this.showFaq,
          toggleShowFaq: this.toggleShowFaq,
          faqItems: FAQ_ITEMS,
          reviewDecks: _state.AppUI.filteredReviewDecks,
          reviewCards: _state.DeckUI.reviewCards,
          deckId: this.deckId,
          onSetDeckId: this.onSetDeckId,
          reviewDeckOptions: _state.AppUI.reviewDeckOptions,
          allReviewsSelectedForCardType: this.allReviewsSelectedForCardType,
          findReviewCardForCard: this.findReviewCardForCard,
          getDecksWithReviewCard: this.getDecksWithReviewCard,
          showCardInSummary: this.showCardInSummary,
          summaryTranslationForCard: this.summaryTranslationForCard
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "loadingReviewCards", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return true;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "hasLearnedWords", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "showFaq", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "reviewCards", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return [];
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "updatedDeckId", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class2.prototype, "showCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showCard"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "deckId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "deckId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wordCardIds", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wordCardIds"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardTypesForPotentialReview", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardTypesForPotentialReview"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardsForPotentialReview", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardsForPotentialReview"), _class2.prototype), _class2)) || _class;
};
DeckSummaryCardWrapper.displayName = 'DeckSummaryCardWrapper';
var _default = exports["default"] = DeckSummaryCardWrapper;